export default __webpack_public_path__ + "static/media/benefits1mx.b6f9678b.png";